import { useTranslation } from "react-i18next";

import Header from "@components/configurations/header";
import {ReactComponent as SmsIcon} from "@assets/sideMenuIcon/info.svg"
import SmsRecipientsTable from "@components/configurations/users_config/sms_recipients";

export const SmsRecipients = () => {
  const { t } = useTranslation();
  
  return (
    <>
      <Header title={t("SMS Recipients")} icon={<SmsIcon fill={"#707070"} />}/>
      <SmsRecipientsTable/>
    </>
  );
};
